/// <amd-module name="VSS/Features/PlatformUI/ContributedPillGroup" />
export { addPills, ContributedPillGroup, getPills } from "./Components/ContributedPillGroup/ContributedPillGroup";
export { IContributedPill, IContributedPillGroupProps } from "./Components/ContributedPillGroup/ContributedPillGroup.Props";
